<style scoped>
::v-deep .vs__dropdown-menu {
    z-index: 1002;
}
</style>
<template>
    <div class="modal-content" ref="container">
        <form>
            <div class="modal-header clearfix">
                <h3 class="modal-title float-left">Start New Workflow</h3>
                <button type="button" aria-label="Close" class="close icon icon-close" @click="close()" />
            </div>
            <div class="modal-body">
                <div class="clearfix">
                    <div class="form-group float-left w-100">
                        <label class="sr-only" for="FormNameVersion">Workflow to start</label>
                        <v-select ref="selectWorkflow" class="w-100" v-model="selectedWorkflow" name="FormNameVersion" :options="possibleNewWorkflowsOptions" @open="openDropdown" :dropdown-should-open="dropdownShouldOpen" label="Label" placeholder="Select a workflow..." :clearable="false"> </v-select>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" id="startBtn" @click="start">Start</button>
                <button type="button" class="btn btn-bare" id="cancelBtn" @click="close">Cancel</button>
            </div>
        </form>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed, SetupContext, nextTick } from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
type Props = {
    possibleNewWorkflows: Record<string, unknown>[];
    startCallback: (workflow: Record<string, unknown>) => void;
} & DialogProps;
let dropdownShouldOpen: () => boolean = undefined!;
export default defineComponent({
    props: ["possibleNewWorkflows", "startCallback", "triggerElement"],
    forceOpenDropdown() {
        dropdownShouldOpen = () => true;
    },
    setup(props: Props, ctx: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef, props);
        const selectWorkflow = ref<InstanceType<typeof vSelect>>(null!);
        const selectedWorkflow = ref(null as Record<string, unknown> | null);

        const possibleNewWorkflowsOptions = computed(() => {
            return props.possibleNewWorkflows.map(i => ({
                Label: i.TaskLabel ? `${i.TaskLabel} (${i.FormLabel})` : i.FormLabel,
                ...i,
            }));
        });

        const start = async () => {
            if (selectedWorkflow.value != null) {
                ctx.emit("close");
                props.startCallback(selectedWorkflow.value!);
            }
        };
        const close = () => {
            ctx.emit("close");
        };
        const openDropdown = async () => {
            // Set search input's own aria label and required data if no selected option
            selectWorkflow.value.searchEl.closest("[role='combobox']").setAttribute("aria-label", "Form");
            await nextTick();
            selectWorkflow.value.$el.querySelectorAll("ul").forEach((elem: HTMLElement) => {
                elem.setAttribute("aria-label", "Workflow to start");
            });
        };
        return {
            // Refs
            selectWorkflow,
            container: containerRef,

            // States
            selectedWorkflow,

            // Computed
            possibleNewWorkflowsOptions,

            // Methods
            start,
            close,
            openDropdown,

            dropdownShouldOpen,
        };
    },
    components: {
        "v-select": vSelect,
    },
});
</script>
